import { CdkMenuItemCheckbox, CdkMenuItemRadio } from "@angular/cdk/menu";
import { booleanAttribute, Component, effect, inject, input, ViewEncapsulation } from "@angular/core";
import { outputFromObservable } from "@angular/core/rxjs-interop";
import { VdsIconComponent } from "@cce/design-system/icon";

@Component({
    selector: "button[vdsMenuItemRadio]",
    templateUrl: "./menu-item-selectable.html",
    encapsulation: ViewEncapsulation.None,
    hostDirectives: [CdkMenuItemRadio],
    host: {
        class: "vds-menu-item vds-menu-item-selectable",
        "[class.vds-menu-item-selectable--checked]": "checked()"
    },
    imports: [VdsIconComponent]
})
export class VdsMenuItemRadio {
    private cdkMenuItem = inject(CdkMenuItemRadio, { self: true });

    readonly checked = input(this.cdkMenuItem.checked, { transform: booleanAttribute });

    readonly disabled = input(this.cdkMenuItem.disabled, { transform: booleanAttribute });

    readonly triggered = outputFromObservable(this.cdkMenuItem.triggered);

    constructor() {
        effect(() => (this.cdkMenuItem.checked = this.checked()));
        effect(() => (this.cdkMenuItem.disabled = this.disabled()));
    }
}

@Component({
    selector: "button[vdsMenuItemCheckbox]",
    templateUrl: "./menu-item-selectable.html",
    encapsulation: ViewEncapsulation.None,
    hostDirectives: [CdkMenuItemCheckbox],
    host: {
        class: "vds-menu-item vds-menu-item-selectable",
        "[class.vds-menu-item-selectable--checked]": "checked()"
    },
    imports: [VdsIconComponent]
})
export class VdsMenuItemCheckbox {
    private cdkMenuItem = inject(CdkMenuItemCheckbox, { self: true });

    readonly checked = input(this.cdkMenuItem.checked, { transform: booleanAttribute });

    readonly disabled = input(this.cdkMenuItem.disabled, { transform: booleanAttribute });

    readonly triggered = outputFromObservable(this.cdkMenuItem.triggered);

    constructor() {
        effect(() => (this.cdkMenuItem.checked = this.checked()));
        effect(() => (this.cdkMenuItem.disabled = this.disabled()));
    }
}
